var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64 9.947a.208.208 0 00-.244.206v2.871a.21.21 0 01-.061.148l-5.05 5.05a1.042 1.042 0 001.472 1.473l3.283-3.278a.208.208 0 01.356.147v2.394a1.042 1.042 0 002.083 0V16.56a.208.208 0 01.354-.143l3.283 3.282a1.042 1.042 0 001.473-1.473l-5.05-5.05a.21.21 0 01-.061-.148v-2.624a.193.193 0 00-.075-.152zM16.583.176c-.156-.1-3.637-.505-5.038.408-.61.398-1.288.924-1.553 1.133a.43.43 0 01-.167.078L3.742 3.198a1.513 1.513 0 00-1.138 1.426v2.007a1.44 1.44 0 001.167 1.386l6.052 1.046a.423.423 0 01.187.083c.26.205.932.724 1.533 1.117a6.028 6.028 0 003 .584 9.833 9.833 0 002.04-.18c.148-.096 1.44-1.06 1.44-5.25S16.728.272 16.582.176z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.c8df119c.svg";
export { ForwardRef as ReactComponent };